import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", { d: "M5.642 18.37a1.224 1.224 0 010-1.74A8.972 8.972 0 0112 14a8.971 8.971 0 016.358 2.63 1.224 1.224 0 010 1.74A8.972 8.972 0 0112 21a8.972 8.972 0 01-6.358-2.63z" }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8.5 7.5h7V8h.5c0 2.637-1.681 5-4 5s-4-2.363-4-5h.5v-.5zm.523 1C9.213 10.568 10.566 12 12 12s2.787-1.432 2.977-3.5H9.023z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 3c2.485 0 4.5 2.239 4.5 5h-9c0-2.761 2.015-5 4.5-5zm0 4.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM6.5 8.5A.5.5 0 017 8h10a.5.5 0 110 1H7a.5.5 0 01-.5-.5z",
      "clip-rule": "evenodd"
    })
  ]))
}